export const initGTMHead = () => {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    let f = document.getElementsByTagName('script')[0],
        script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-59T5678';
    f.parentNode.insertBefore(script, f);
};
